'use strict';

const React = require('react');
const PropTypes = require('prop-types');

/**
 *
 * @type {{label: string, trackingLabel: string, path: string}[]}
 */
const INITIAL_CONFIG = [
    {
        label: 'Home',
        trackingLabel: 'home',
        path: '/',
    },
];

/**
 * Render a breadcrumb arrow.
 */
const Arrow = ({ breadcrumbIndex, totalBreadcrumbs }) => {
    // Don't add the arrow if this is the last breadcrumb.
    if (breadcrumbIndex + 1 === totalBreadcrumbs) {
        return null;
    }
    return <span className="page-breadcrumb-divider">&#47;</span>;
};

Arrow.propTypes = {
    // The index of the current breadcrumb
    breadcrumbIndex: PropTypes.number.isRequired,

    // The total number of breadcrumbs
    totalBreadcrumbs: PropTypes.number.isRequired,
};

/**
 * Render an individual breadcrumb.
 */
const Breadcrumb = ({ breadcrumbData, breadcrumbIndex, totalBreadcrumbs, callback = () => {} }) => {
    const { path, label } = breadcrumbData;

    return (
        <li className="page-breadcrumb" key={breadcrumbIndex}>
            <a
                className="page-breadcrumb-link"
                href={path}
                onClick={() => callback(breadcrumbData)}
            >
                <span>{label}</span>
            </a>
            <meta content={breadcrumbIndex + 1} />
            {Arrow({
                // eslint-disable-line new-cap
                breadcrumbIndex,
                totalBreadcrumbs,
            })}
        </li>
    );
};

Breadcrumb.propTypes = {
    // The configuration for the current breadcrumb
    breadcrumbData: PropTypes.shape({
        path: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        trackingLabel: PropTypes.string,
    }).isRequired,

    // The index of the current breadcrumb
    breadcrumbIndex: PropTypes.number.isRequired,

    // The total number of breadcrumbs
    totalBreadcrumbs: PropTypes.number.isRequired,

    // Optional callback to fire on breadcrumb click
    callback: PropTypes.func,
};

/**
 * Render breadcrumbs for page.
 */
const PageBreadcrumbs = ({ config, addInitialConfig, itemClickCallback }) => {
    if (addInitialConfig) {
        config = INITIAL_CONFIG.concat(config);
    }
    return (
        // Todo: Move that helper file somewhere more global
        <ul className="page-breadcrumbs">
            {config.map((breadcrumbData, breadcrumbIndex) => {
                return Breadcrumb({
                    // eslint-disable-line new-cap
                    callback: itemClickCallback,
                    totalBreadcrumbs: config.length,
                    breadcrumbData,
                    breadcrumbIndex,
                });
            })}
        </ul>
    );
};

PageBreadcrumbs.propTypes = {
    config: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            trackingLabel: PropTypes.string,
        })
    ).isRequired,

    // Optional boolean that if true, prepends initial config to config in props
    addInitialConfig: PropTypes.bool,

    // Optional callback to be passed to each individual breadcrumb. This will be passed an object containing the
    // `path`, `label` and `trackingLabel` for that breadcrumb.
    itemClickCallback: PropTypes.func,
};

module.exports = PageBreadcrumbs;



// WEBPACK FOOTER //
// ./assets/js/global/components/PageBreadcrumbs.jsx